module.exports = __webpack_public_path__ + "assets/img/1_1641.10af872f.jpg";